import { render, staticRenderFns } from "./StatementItem.vue?vue&type=template&id=39f44065&scoped=true"
import script from "./StatementItem.vue?vue&type=script&lang=js"
export * from "./StatementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f44065",
  null
  
)

export default component.exports